// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Merged pages from full inheritance chain + local overrides.
// Generated: 2026-08-27T21:34:05.874Z
import pagesData from './vibesites-pages.json';
import { mergePages, resolvePageTokens, isActivePage } from '@vibesites/runtime';
import type { PageComposition } from '@vibesites/runtime';

const resolved = mergePages(pagesData as any).filter(isActivePage);
export const pages: Record<string, PageComposition> = Object.fromEntries(
  resolved.map(p => [p.alias, resolvePageTokens(p)])
);

export default pages;
